module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "view-slide-container"
    }
  }, [_c('div', {
    staticClass: "container is-fluid levebar-container"
  }, [_c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left is-hidden-mobile"
  }, [(_vm.breadcrumbList) ? _c('breadcrumb', {
    attrs: {
      "list": _vm.breadcrumbList
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "view-slide"
    }
  }, [(_vm.menu) ? _c('sub-menu-info', {
    attrs: {
      "menu": _vm.menu,
      "title": "Características dos Sub-slides "
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-comp"
  }), _vm._v(" "), _c('slide-list', {
    attrs: {
      "slides": _vm.slides,
      "parent": _vm.parent_slide,
      "menu": _vm.menu
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4eef2a79!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide/SubSlide.vue
// module id = 321
// module chunks = 1